class Reponse {
  r1?: string;
  r2?: string;
  r3?: string;
  r4?: string;
  r5?: string;
  r6?: string;
  r7?: string;
  r8?: string;
  reponseLibre: string = '';
  valeurLibre: string = '';
  valeurUnite: string = '';
  photo?: string; 
}

export default class Response {
  currentQuestionnaire: string = '';
  currentReponse: string = "{}";
  question: string = '';
  questionId: string = '';
  reponse: Reponse = new Reponse();
  visioId?: string;
}